export default __webpack_public_path__ + "static/media/pictogramBeaconMultipleDocuments40.b31c9cca.svg";